import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
    const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 18 18"
  >
    <g>
      <g fill={colorValue} fillRule="evenodd" clipRule="evenodd">
        <path d="M14.625 7.313a.562.562 0 01-.563.562h-3.374a.562.562 0 01-.563-.562V3.938a.562.562 0 011.125 0v2.017l3.54-3.54a.563.563 0 11.795.795l-3.54 3.54h2.018a.562.562 0 01.562.563z"></path>
        <path d="M1.125 3.375a2.25 2.25 0 012.25-2.25h1.029c.645 0 1.208.44 1.364 1.065l.829 3.317a1.406 1.406 0 01-.52 1.466l-.97.728c-.102.076-.123.187-.095.264a8.464 8.464 0 005.023 5.023c.077.028.188.007.264-.095l.728-.97a1.407 1.407 0 011.466-.52l3.317.829c.626.157 1.065.719 1.065 1.365v1.028a2.25 2.25 0 01-2.25 2.25h-1.688c-6.523 0-11.812-5.289-11.812-11.813V3.375z"></path>
      </g>
    </g>
  </svg>
  );
};
